module.exports = __webpack_public_path__ + "static/media/Newsreader-VariableFont_opsz,wght.1b9ef251.ttf";